export default __webpack_public_path__ + "static/img-credit-score-benefit--mobile-a397dc71641364a5fc22cab67fcbf865.webp";